"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdminUserGroups_vue_1 = __importDefault(require("../../pages/adminUserGroups/AdminUserGroups.vue"));
const AdminUsers_vue_1 = __importDefault(require("../../pages/adminUsers/AdminUsers.vue"));
const AdminTranslations_vue_1 = __importDefault(require("../../pages/adminTranslations/AdminTranslations.vue"));
const ReservationCalendar_vue_1 = __importDefault(require("../../pages/backend/reservations/calendar/ReservationCalendar.vue"));
const ReservationsList_vue_1 = __importDefault(require("../../pages/backend/reservations/list/ReservationsList.vue"));
const Locations_vue_1 = __importDefault(require("../../pages/backend/locations/Locations.vue"));
const LocationForm_vue_1 = __importDefault(require("../../pages/backend/locations/LocationForm/LocationForm.vue"));
const Services_vue_1 = __importDefault(require("../../pages/backend/services/Services.vue"));
const ServiceForm_vue_1 = __importDefault(require("../../pages/backend/services/ServiceForm.vue"));
const ExcludedDays_vue_1 = __importDefault(require("../../pages/backend/excluded_days/ExcludedDays.vue"));
exports.default = [
    {
        name: "admin_user_groups",
        path: "/admin/user-groups",
        component: AdminUserGroups_vue_1.default,
        meta: { requiresAuth: true, title: "User Groups" },
    },
    {
        name: "admin_user_groups_api",
        path: "/api/user-groups/:id(\\d+)?",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "admin_users",
        path: "/admin/users",
        component: AdminUsers_vue_1.default,
        meta: { requiresAuth: true, title: "Users" },
    },
    {
        name: "admin_users_api",
        path: "/api/users/:id(\\d+)?",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "admin_translations",
        path: "/admin/translations",
        component: AdminTranslations_vue_1.default,
        meta: { requiresAuth: true, title: "Translations" },
    },
    {
        name: "admin_translations_api",
        path: "/api/translations",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "admin_translations_api_write_out_translations",
        path: "/api/write-out-translations",
        redirect: "",
        meta: { requiresAuth: true },
    },
    {
        name: "reservations_calendar_view",
        path: "/admin/reservations-calendar",
        component: ReservationCalendar_vue_1.default,
        meta: { requiresAuth: true, title: "Reservations Calendar View" },
    },
    {
        name: "reservations_list_view",
        path: "/admin/reservations-list",
        component: ReservationsList_vue_1.default,
        meta: { requiresAuth: true, title: "Reservations List View" },
    },
    {
        name: "location_view",
        path: "/admin/locations",
        component: Locations_vue_1.default,
        meta: { requiresAuth: true, title: "Locations" },
    },
    {
        name: "location_form_view",
        path: "/admin/locations/edit",
        component: LocationForm_vue_1.default,
        meta: { requiresAuth: true, title: "Locations Edit" },
    },
    {
        name: "services",
        path: "/admin/services",
        component: Services_vue_1.default,
        meta: { requiresAuth: true, title: "Services" },
    },
    {
        name: "service_new",
        path: "/admin/services/new",
        component: ServiceForm_vue_1.default,
        meta: { requiresAuth: true, title: "New Service" },
    },
    {
        name: "service_edit",
        path: "/admin/services/edit/:id(\\d+)",
        component: ServiceForm_vue_1.default,
        meta: { requiresAuth: true, title: "Services Edit" },
    },
    {
        name: "excluded_days",
        path: "/admin/excluded-days",
        component: ExcludedDays_vue_1.default,
        meta: { requiresAuth: true, title: "Excluded days" },
    },
];
